import React from 'react';
import { Form, Input, Button, Row, Col, message, Card } from 'antd';
import AuthService from '../../services/AuthService';
import { openNotification } from '../../utils';


const PasswordChangeForm = () => {
    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = React.useState<boolean>(false);

    const passwordRules = [
        { required: true, message: 'Lütfen parolanızı giriniz!' },
        { min: 12, message: 'Parola en az 12 karakter olmalıdır.' },
        {
            pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{12,})'),
            message: 'Parola büyük harf, küçük harf, sayı ve özel karakter içermelidir.'
        },
    ];

    const handleSubmit = (values: any) => {
        setLoading(true);

        AuthService.changePassword({
            oldPassword: values.oldPassword,
            newPassword: values.newPassword,
        })
            .then(() => {
                openNotification('success', 'Başarılı', 'Şifre Başarıyla Değiştirildi!');
            })
            .catch((error) => {
                const errorMessage = error?.response?.data?.message || 'Şifre Değiştirilemedi';
                openNotification('error', 'Hata', errorMessage);
            })
            .finally(() => setLoading(false));
    };

    return (
        <>
            <Card loading={loading} style={{width:"100%", marginTop:"2rem"}}>
                <Form style={{ width: "100%" }}
                    name="passwordChange"
                    onFinish={handleSubmit}
                >
                    <Row>
                        <Col style={{ padding: "1em" }} lg={8} md={12} sm={24} xs={24}>
                            <Form.Item
                                name="oldPassword"
                                rules={[{ required: true, message: 'Lütfen eski şifrenizi giriniz!' }]}
                            >
                                <Input.Password size='large' placeholder="Eski Şifre" />
                            </Form.Item>

                        </Col>
                        <Col style={{ padding: "1em" }} lg={8} md={12} sm={24} xs={24}>
                            <Form.Item
                                name="newPassword"
                                rules={passwordRules}
                            >
                                <Input.Password size='large' placeholder="Yeni Şifre" />
                            </Form.Item>
                        </Col>
                        <Col style={{ padding: "1em" }} lg={8} md={12} sm={24} xs={24}>
                            <Form.Item
                                name="confirmPassword"
                                dependencies={['newPassword']}
                                rules={[
                                    { required: true, message: 'Lütfen yeni şifrenizi tekrar giriniz!' },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('newPassword') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('Şifreler eşleşmiyor!'));
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password size='large' placeholder="Yeni Şifre Tekrar" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ padding: "1em" }}>
                            <Button type="primary" htmlType="submit" size="large">
                                Şifreyi Değiştir
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
            {contextHolder}
        </>
    );
};

export default PasswordChangeForm;
